import AcceptedConsentsTable from '@/features/dashboard/acceptedConsents/components/AcceptedConsentsTable.tsx';
import { contractsRoute } from '@/features/dashboard/acceptedConsents/routes/contractsRoute.ts';

const ContractsPage = () => {
  const search = contractsRoute.useSearch();
  return <AcceptedConsentsTable listSearch={search} />;
};

export default ContractsPage;
